<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <!-- <Menu></Menu> -->
                    <div class="search_form">
                        <div class="sns">
                            <ul>
                                <li v-for="(item, idx) in sns.list" :class="{ disabled: !item.isUsed }">
                                    <img :src="item.status === 0 ? sns.imgUrl_gray[idx] : sns.imgUrl_color[idx]" @click="selectSns(item)" />
                                </li>
                            </ul>
                        </div>
                        <div class="search_input">
                            <div class="search_keyword">
                                <p class="search_type">Keyword</p>
                                <input
                                    type="text"
                                    v-model="state.keyword"
                                    name="searchKeyword"
                                    class="searchKeyword"
                                    placeholder="키워드를 입력하세요"
                                    @keydown.enter="searchApi"
                                />
                            </div>
                        </div>
                        <div class="search_btn">
                            <button @click="searchApi">검색</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal_bg" v-if="state.isLoading">
        <Spinner></Spinner>
    </div>
</template>
<script lang="ts" config>
    import { globalStore, reactive, Header, onMounted, Menu, returnCode, Spinner, apiService, router } from "@/BaseComponent";

    interface SnsIcon {
        title: string;
        status: number;
        isUsed: boolean;
    }
    export default {
        props: {},
        components: {
            Header,
            Menu,
            Spinner,
        },
        setup() {
            const { changeCode } = returnCode();
            const global = globalStore();
            const state = reactive({
                isLoading: false as boolean,
                keyword: "" as string,
            });
            const sns = reactive({
                list: [
                    {
                        title: "isTelegram" as string,
                        status: 1 as number,
                        isUsed: true,
                    },
                    {
                        title: "isDiscord" as string,
                        status: 0 as number,
                        isUsed: false,
                    },
                ] as SnsIcon[],
                imgUrl_color: [require("@/assets/sns/telegram.png"), require("@/assets/sns/discord.png")],
                imgUrl_gray: [require("@/assets/sns/telegram_gy.png"), require("@/assets/sns/discord_gy.png")],
            });

            onMounted(() => {
                global.setSelectMenu(4);
            });

            const selectSns = (item: SnsIcon) => {
                // 디스코드 사용불가
                if (item.title === "isDiscord") return;

                if (item.status === 0) item.status = 1;
                else item.status = 0;
            };

            const searchApi = async () => {
                if (sns.list.every((item) => item.status === 0)) return alert("플랫폼을 선택해주세요.");
                else if (state.keyword === "") return alert("키워드를 입력해주세요.");
                else if (state.keyword.length < 3) return alert("3글자 이상 입력해주세요.");

                state.isLoading = true;
                const param = {
                    isTelegram: sns.list[0].status,
                    keyword: state.keyword,
                };
                const res = await apiService.searchRoom.search(param);
                if (res.returnCode === 0) {
                    router.push("/watcherbot/search/history");
                } else {
                    alert(changeCode(res.returnCode));
                }
                state.isLoading = false;
            };

            return {
                sns,
                state,
                selectSns,
                searchApi,
            };
        },
    };
</script>
<style scoped>
    .content {
        padding: 20px 0;
    }
    .sns ul li.disabled {
        cursor: no-drop;
    }
</style>
